import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import cx from 'classnames2';
import React from 'react';
import { Description } from '../../Description';
import { Icon } from '../../Icon';
import styles from './Dropdown.Item.scss';
export var DropdownItem = function DropdownItem(props) {
  var itemLabel = React.createElement(React.Fragment, null, props.icon && React.createElement("span", {
    className: styles.iconWrapper
  }, React.createElement(Icon, {
    icon: props.icon,
    ariaHidden: true
  })), React.createElement("span", {
    className: styles.label
  }, props.label, props.description ? React.createElement(Description, {
    className: styles.description
  }, props.description) : null));

  if (props.href) {
    var _cx;

    return React.createElement("li", {
      className: "".concat(styles.dropdownItemContainer, " ").concat(props.className)
    }, React.createElement("a", {
      className: cx(styles.dropdownItem, (_cx = {}, _defineProperty(_cx, styles.hasDescription, props.description), _defineProperty(_cx, styles.itemDisabled, props.disabled), _cx)),
      "data-test": props.dataTest,
      href: props.disabled ? null : props.href
    }, itemLabel));
  } else {
    var _cx2;

    return React.createElement("li", {
      className: "".concat(styles.dropdownItemContainer, " ").concat(props.className)
    }, React.createElement("button", {
      className: cx(styles.dropdownItem, (_cx2 = {}, _defineProperty(_cx2, styles.hasDescription, props.description), _defineProperty(_cx2, styles.itemDisabled, props.disabled), _cx2)),
      "data-test": props.dataTest,
      onClick: props.disabled ? null : props.onClick,
      disabled: props.disabled
    }, itemLabel));
  }
};